import React from 'react';
import ReactDOM from 'react-dom';
import * as Sentry from '@sentry/react';
import App from './App';
import * as serviceWorker from './serviceWorkerRegistration';

if (
  process.env.REACT_APP_AUTH_REDIRECT_URL !== 'https://dev-login.beem.africa'
) {
  Sentry.init({
    dsn: 'https://458ee2b1b3cd53a17cd6e96b691e5e51@o430675.ingest.us.sentry.io/5917216',
    tracesSampleRate: 1.0,
    replaysSessionSampleRate: 0.1,
    replaysOnErrorSampleRate: 1.0,
    environment:
      process.env.REACT_APP_AUTH_REDIRECT_URL !==
      'https://dev-login.beem.africa'
        ? 'production'
        : 'development',
    beforeSend(event) {
      const isLoginError = event.exception?.values.some(
        (ex) =>
          ex.value && ex.value.includes('Please login to access resources')
      );

      if (isLoginError) {
        return null;
      }
      return event;
    },
  });
}

const render = (Component) =>
  ReactDOM.render(<Component />, document.getElementById('root')); // eslint-disable-line

render(App);

if (module.hot) {
  module.hot.accept('./App', () => {
    const NextApp = require('./App').default; // eslint-disable-line global-require
    render(NextApp);
  });
}

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: http://bit.ly/CRA-PWA
serviceWorker.register();
